<template>
  <base-card
    title="Informasi Pengiriman"
    description="Detail informasi ongkos kirim"
  >
    <div class="grid grid-cols-3 gap-4 border-t pt-5">
      <base-input
        inset
        label="Total Harga"
        placeholder="Total Harga"
        :value="order.data.attributes.grand_total_price | toCurrency"
        disabled
      />
      <base-input
        inset
        label="Selisih"
        placeholder="Selisih"
        :value="order.data.attributes.shipping_fee | toCurrency"
        disabled
      />
      <base-input
        inset
        label="Plastik"
        placeholder="Plastik"
        :value="order.data.attributes.plastic_qty | toCurrency"
        disabled
      />
    </div>
  </base-card>
</template>

<script>
export default {
  props: {
    order: Object,
  },
};
</script>
